import Vue from 'vue';
import Vuex from 'vuex';

import { abpStore, layoutStore } from './modules';

Vue.use(Vuex);

export default new Vuex.Store({
    strict: true,
    modules: {
        abpStore,
        layoutStore,
    },
    getters: {},
    mutations: {},
    actions: {},
});
